import CloseIcon from '@mui/icons-material/Close';
import { Modal, Button } from '@mui/material';
import TextField from '@mui/material/TextField';
import React, { useEffect, useState, Dispatch, SetStateAction } from 'react';

import { showError, showToast } from '../constants/toasts';
import { useAddFaqMutation, useUpdateFaqMutation } from '../service/cms';
import { CommonBody, FaqRes } from '../types/General';
import { generateEncryptedKeyBody } from '../utils/crypto';

interface AddFaqModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  getFaqs: () => void;
  selectedId: string;
  selectedFaq: FaqRes | undefined | null;
}

export default function AddFaq({
  open,
  onClose,
  setOpen,
  getFaqs,
  selectedId,
  selectedFaq,
}: AddFaqModalProps) {
  const [question, setQuestion] = useState('');
  const [answer, setAnswer] = useState('');
  const [error, setError] = useState(false);
  const [addFaq] = useAddFaqMutation();
  const [updateFaq] = useUpdateFaqMutation();

  const handleSubmit = async () => {
    const body = {
      question: question,
      answer: answer,
    };

    if (body.answer.length < 10 || body.question.length < 10) {
      return;
    }

    try {
      let response;
      if (selectedId) {
        const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
        response = await updateFaq({
          body: encryptedBody,
          id: selectedId,
        }).unwrap();
      } else {
        const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
        response = await addFaq({ body: encryptedBody }).unwrap();
      }

      if (response?.statusCode === 200) {
        setQuestion('');
        setAnswer('');
        setError(false);
        setOpen(false);
        showToast('Faq Added Successfully.');
        getFaqs();
      }
    } catch (error: any) {
      showError(error?.data?.message || '');
    }
  };

  useEffect(() => {
    if (selectedFaq) {
      setQuestion(selectedFaq?.question || '');
      setAnswer(selectedFaq?.answer || '');
    }
  }, [selectedFaq]);

  return (
    <Modal
      className="modal addNotification_modal"
      id="addFaqModal"
      aria-labelledby="addFaq-modal-title"
      aria-describedby="addFaq-modal-description"
      open={open}
      onClose={() => {
        onClose();
        setError(false);
      }}
    >
      <div className="modal-dialog">
        <div className="modal-body">
          <div
            className="btn-close"
            onClick={() => {
              setQuestion('');
              setAnswer('');
              setOpen(false);
            }}
          >
            <CloseIcon />
          </div>
          <div className="modal_title">
            <h2>{selectedId ? 'Edit' : 'Add'} FAQ</h2>
          </div>
          <form className="form" action="">
            <div className="control_group">
              <TextField
                variant="outlined"
                placeholder="Question"
                fullWidth
                value={question}
                onChange={(e) => {
                  if (e.target.value === ' ' || e.target.value === '.') {
                  } else {
                    setQuestion(e.target.value);
                  }
                }}
                hiddenLabel
              />
              {error && question == '' ? (
                <h6 className="err_msg">Question is required</h6>
              ) : error && question?.length < 10 ? (
                <h6 className="err_msg">Minimum 10 characters are required</h6>
              ) : (
                ''
              )}
            </div>
            <div className="control_group">
              <TextField
                variant="outlined"
                placeholder="Answer"
                fullWidth
                hiddenLabel
                multiline
                value={answer}
                onChange={(e) => {
                  if (e.target.value === ' ' || e.target.value === '.') {
                  } else {
                    setAnswer(e.target.value);
                  }
                }}
                maxRows={5}
                minRows={5}
              />
              {error && answer == '' ? (
                <h6 className="err_msg">Answer is required</h6>
              ) : error && answer?.length < 10 ? (
                <h6 className="err_msg">Minimum 10 characters are required</h6>
              ) : (
                ''
              )}
            </div>
            <div className="footer_btn_flex">
              <Button
                className="btn btn_highlight"
                onClick={() => {
                  setError(false);
                  setOpen(false);
                  setQuestion('');
                  setAnswer('');
                }}
              >
                Cancel
              </Button>
              <Button
                className="btn btn_secondary"
                onClick={() => {
                  setError(true);
                  if (question == '') {
                    return;
                  }
                  if (answer == '') {
                    return;
                  }
                  handleSubmit();
                }}
              >
                Submit
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
